import React, { useEffect, useState } from 'react'
import { toast, ToastContainer } from "react-toastify";

import "common/css/master.css";

import { saveSubjectTeacherSvc } from './manualAllocationSvc';

const ManualAllocationTable = (props) => {
    const { lstSub, syllabusId, clsId, sectionId, setEditLoader, setEditOpacity, flgUpdateTimetable, flgAvoidClash } = props;

    const [lstSubject, setLstSubject] = useState([]);
    const [subId, setSubId] = useState(0);

    useEffect(() => {
        // console.log("useEffect in ManualAllocationTable component called, lstSub", lstSub);
        // console.log("syllabusId", syllabusId);
        // console.log("sectionId", sectionId);
        // console.log("clsId", clsId);
        setLstSubject(lstSub);
    }, [lstSub, syllabusId, clsId, sectionId]);

    const handleTeacherChange = (pSubId, pTchId) => {
        // console.log("handleTeacherChange called, pSubId", pSubId, ", pTchId", pTchId);
        saveTeacherAllocation(pSubId, pTchId, false);//flgAddlTch:false
    }
    const handleAddlTeacherChange = (pSubId, pTchId) => {
        // console.log("handleAddlTeacherChange called, pSubId", pSubId, ", pTchId", pTchId);
        saveTeacherAllocation(pSubId, pTchId, true);//flgAddlTch:true
    }

    const saveTeacherAllocation = (pSubId, pTchId, flgAddlTch) => {
        // console.log("saveTeacherAllocation called", pSubId, pTchId);
        if (pTchId == 0) {
            let userConfirmed;
            if (flgAddlTch) {
                userConfirmed = window.confirm("Are you sure you want to remove additional teacher allocation?");
            } else {
                userConfirmed = window.confirm("Are you sure you want to remove teacher allocation?");
            }
            if (userConfirmed) {
                setEditLoader("block");
                setEditOpacity(0.5);
                let tempTchId = 0;

                tempTchId = lstSubject.find(item => item.subjectId === pSubId)?.tchId || 0;
                saveSubjectTeacherSvc(sectionId, syllabusId, pSubId, tempTchId, false, flgAddlTch, flgUpdateTimetable,flgAvoidClash, removeManualAllocationResponse);
            }
        } else {
            setEditLoader("block");
            setEditOpacity(0.5);
            saveSubjectTeacherSvc(sectionId, syllabusId, pSubId, pTchId, true, flgAddlTch, flgUpdateTimetable, flgAvoidClash, saveManualAllocationResponse);
        }
    };
    const removeManualAllocationResponse = async (data, pFlgAddlTch) => {
        // console.log("removeManualAllocationResponse called, data", data);
        if (data.status === "Success") {
            toast.success(data.message);
            let tempLstSubject = [...lstSubject];
            for (let i = 0; i < tempLstSubject.length; i++) {
                if (tempLstSubject[i].subjectId === data.subjectId) {
                    // console.log("before change tempLstSubject[i]", tempLstSubject[i]);
                    if (pFlgAddlTch) {
                        tempLstSubject[i] = { ...tempLstSubject[i], addlTchId: 0 }
                    } else {
                        tempLstSubject[i] = { ...tempLstSubject[i], tchId: 0 }
                    }
                    // console.log("after change tempLstSubject[i]", tempLstSubject[i]);
                    break;
                }
            }
            // console.log("tempLstSubject", tempLstSubject);
            setLstSubject(tempLstSubject);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setEditLoader("none");
        setEditOpacity(1);
    }

    const saveManualAllocationResponse = async (data, pFlgAddlTch) => {
        // console.log("saveManualAllocationResponse called, data", data);
        if (data.status === "Success") {
            toast.success(data.message);
            let tempLstSubject = [...lstSubject];
            for (let i = 0; i < tempLstSubject.length; i++) {
                if (tempLstSubject[i].subjectId === data.subjectId) {
                    // console.log("before change tempLstSubject[i]", tempLstSubject[i]);
                    if (!pFlgAddlTch) {
                        tempLstSubject[i] = { ...tempLstSubject[i], tchId: data.tchId }
                    } else {
                        tempLstSubject[i] = { ...tempLstSubject[i], addlTchId: data.tchId }

                    }
                    // console.log("after change tempLstSubject[i]", tempLstSubject[i]);
                    break;
                }
            }
            // console.log("tempLstSubject", tempLstSubject);
            setLstSubject(tempLstSubject);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setEditLoader("none");
        setEditOpacity(1);
    }
    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };

    const colgrp = <colgroup>
        <col width="50"></col>
        <col width="50"></col>
        <col width="50"></col>
    </colgroup>


    return (
        <div >
            <div className="col-md-12 col-xs-12 col-centered padding-remove " >
                <table className="tableLayout1" >
                    {colgrp}
                    <thead>
                        <tr>
                            <th >
                                Subject
                            </th>
                            <th >
                                Teacher
                            </th>
                            <th >
                                Additional Teacher
                            </th>
                        </tr>
                    </thead>
                </table>
                <div className="tableDiv" style={{ height: "70vh" }}>
                    <table className="tableLayout">
                        {colgrp}
                        <tbody id="subjectTeacherTable" >
                            {lstSubject &&
                                lstSubject.map((subject, i) => (
                                    <tr key={subject.subjectId}
                                        onClick={() => setSubId(subject.subjectId)}
                                        className={subject.subjectId === subId ? "selected" : ''}>
                                        <td className="text-left">{subject.subject}</td>
                                        <td className="text-center">
                                            <div className="col-md-12 padding-remove">
                                                <div className="col-md-12 col-centered padding-remove">
                                                    <select
                                                        className="form-control"
                                                        value={subject.tchId}
                                                        onChange={(e) => handleTeacherChange(subject.subjectId, e.target.value)}
                                                    >
                                                        <option value={0}>Teacher</option>
                                                        {subject.lstTch.map((tch, index) => (
                                                            <option key={tch.tchId} value={tch.tchId}>{tch.tch}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="text-center">
                                            <div className="col-md-12 padding-remove">
                                                <div className="col-md-12 col-centered padding-remove">
                                                    <select
                                                        className="form-control"
                                                        value={subject.addlTchId}
                                                        onChange={(e) => handleAddlTeacherChange(subject.subjectId, e.target.value)}
                                                    >
                                                        <option value={0}>Additional Teacher</option>
                                                        {subject.lstTch.map((tch, index) => (
                                                            <option key={tch.tchId} value={tch.tchId}>{tch.tch}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default ManualAllocationTable;